import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface LogoProps {
  className?: string;
  alt?: string;
  height?: number;
  width?: number;
}

const Logo: React.FC<LogoProps> = ({ className = 'h-12 w-auto', alt = 'Mermaid Logo', height, width }) => {
  const { theme } = useTheme();

  // Determinar qual logo usar baseado no tema
  const logoSrc = theme === 'dark' ? '/mermaid_logo_dark.png' : '/mermaid_logo_light.png';

  return <img src={logoSrc} alt={alt} className={className} height={height} width={width} />;
};

export default Logo;
